import { render, staticRenderFns } from "./ReportMatrixAttemptsDelivered.vue?vue&type=template&id=123d088a"
import script from "./ReportMatrixAttemptsDelivered.vue?vue&type=script&lang=js"
export * from "./ReportMatrixAttemptsDelivered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports